import FavoriteButton from "../FavoriteButton";
import FreeProFlag from "../FreeProFlag";
import Spinner from "../Spinner";

interface TemplateCardProps {
  design: any;
  free: boolean;
  isFreemium: boolean;
  loading: boolean;
  useTemplate: (design: any) => void;
  showFavorite?: boolean;
  isFavorite?: boolean;
  name?: string;
  toggleFavoriteCallback?: () => void;
}

export default function TemplateCard({ design, free, isFreemium, loading, useTemplate, isFavorite = false, name, showFavorite = false, toggleFavoriteCallback }: TemplateCardProps) {

  return <div className={'design ' + (design.isVisible ? '' : 'hidden')}>
  <div className="inner">
    <div className="img-wrap">
      <FreeProFlag free={free} isFreemium={isFreemium} />
      <img loading={"lazy"} onClick={() => useTemplate(design)} src={design.defaultThumbnailPath} alt={'thumbnail'} />
      {loading === design.id && <div className="template-spinner">
        <Spinner />
      </div>}
      {showFavorite && <FavoriteButton assetId={design.id} type="template" isFavorite={isFavorite} callback={toggleFavoriteCallback} />}
    </div>
    {name && <h5>{name}</h5>}
  </div>
</div>

}
